import en from '../../i18n/locales/en.json'
import fr from '../../i18n/locales/fr.json'

type RoleText = 'purpose' | 'accountabilities'

interface RoleTexts {
  base: boolean
  purpose: string
  accountabilities: string
}

// Every purpose and accountabilities text a model seeds on its base roles, in
// every language: an org created in English and read in French still holds the
// English text.
export const seededRoleTexts: ReadonlySet<string> = new Set(
  [fr, en].flatMap((locale) =>
    Object.values(locale.Onboarding.roles).flatMap((role) => [
      role.purpose.trim(),
      role.accountabilities.trim(),
    ])
  )
)

// #148: whether someone actually wrote a purpose or accountabilities. A model
// creates its base roles WITH their texts (useSeedOrg), so a non-empty field
// proves nothing there: a base role only counts once its text differs from
// what was seeded. A team role counts as soon as it holds a text.
//
// ⚠️ A text seeded by an older wording of the models reads as written: the
// comparison only knows today's texts.
export function hasWrittenRoleText(
  roles: readonly RoleTexts[],
  field: RoleText,
  seededTexts: ReadonlySet<string> = seededRoleTexts
): boolean {
  return roles.some((role) => {
    const text = role[field].trim()
    if (text === '') return false
    return !role.base || !seededTexts.has(text)
  })
}
